export default __webpack_public_path__ + "static/cotizar_polizas-46aa3cfa77ce7fbb727b19660f94a6e1.mp4";